"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormBuilder = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _ctaButton = require("../buttons/cta-button");
var _get = _interopRequireDefault(require("lodash/get"));
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _assign = _interopRequireDefault(require("lodash/assign"));
var _reduce = _interopRequireDefault(require("lodash/reduce"));
var _forOwn = _interopRequireDefault(require("lodash/forOwn"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _inputField = require("../inputs/input-field");
var _reactIntl = require("react-intl");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var FormBuilder = exports.FormBuilder = /*#__PURE__*/function (_Component) {
  _inherits(FormBuilder, _Component);
  function FormBuilder(props) {
    var _this;
    _classCallCheck(this, FormBuilder);
    _this = _callSuper(this, FormBuilder, [props]);
    _this.state = {
      submitted: false
    };
    _this.formRefs = {};
    _this.getHeading = _this.getHeading.bind(_assertThisInitialized(_this));
    _this.getSmallHeading = _this.getSmallHeading.bind(_assertThisInitialized(_this));
    _this.getSubheading = _this.getSubheading.bind(_assertThisInitialized(_this));
    _this.getDescription = _this.getDescription.bind(_assertThisInitialized(_this));
    _this.submitForm = _this.submitForm.bind(_assertThisInitialized(_this));
    _this.isScrolledIntoView = _this.isScrolledIntoView.bind(_assertThisInitialized(_this));
    _this.scrollErrorIntoView = _this.scrollErrorIntoView.bind(_assertThisInitialized(_this));
    _this.inputsValid = _this.inputsValid.bind(_assertThisInitialized(_this));
    _this.toggleSubmitted = _this.toggleSubmitted.bind(_assertThisInitialized(_this));
    _this.clearForm = _this.clearForm.bind(_assertThisInitialized(_this));
    _this.shouldButtonBeDisabled = _this.shouldButtonBeDisabled.bind(_assertThisInitialized(_this));
    _this.shouldButtonBeSpinning = _this.shouldButtonBeSpinning.bind(_assertThisInitialized(_this));
    _this.renderInputElements = _this.renderInputElements.bind(_assertThisInitialized(_this));
    _this.renderFormGroups = _this.renderFormGroups.bind(_assertThisInitialized(_this));
    _this.isInputWrappedFunction = _this.isInputWrappedFunction.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(FormBuilder, [{
    key: "getHeading",
    value: function getHeading() {
      if (this.props.heading) {
        return /*#__PURE__*/_react.default.createElement("h3", {
          className: "form-heading"
        }, this.props.heading);
      }
      return null;
    }
  }, {
    key: "getSmallHeading",
    value: function getSmallHeading() {
      if (this.props.smallHeading) {
        return /*#__PURE__*/_react.default.createElement("h4", {
          className: "form-smallheading"
        }, this.props.smallHeading);
      }
      return null;
    }
  }, {
    key: "getSubheading",
    value: function getSubheading() {
      if (this.props.subHeading) {
        return /*#__PURE__*/_react.default.createElement("h6", {
          className: "form-subheading"
        }, this.props.subHeading);
      }
      return null;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      if (this.props.description) {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "form-description"
        }, this.props.description);
      }
      return null;
    }
  }, {
    key: "isInputWrappedFunction",
    value: function isInputWrappedFunction(value) {
      if ((0, _isFunction.default)((0, _get.default)(value, 'getWrappedInstance', ''))) {
        return value.getWrappedInstance();
      }
      if (value && value.refs && value.refs.wrappedInstance) {
        return value.refs.wrappedInstance;
      }
      return value;
    }
  }, {
    key: "submitForm",
    value: function submitForm(e) {
      var _this2 = this;
      e.preventDefault();
      analyticsIntegrations.formSubmit(this.props.formname);
      var formIsValid = this.inputsValid();
      if (!formIsValid) {
        analyticsIntegrations.formFail(this.props.formname, 'Missing or incorrect form inputs');
        return;
      }
      var componentRefs = (0, _mapValues.default)(this.refs, function (value) {
        return _this2.isInputWrappedFunction(value);
      }); //keeping this.refs for backwards compatibility for services still using deprecated string refs
      var inputRefs = (0, _assign.default)({}, componentRefs, this.formRefs, this.props.inputRefs);
      var getValues = (0, _reduce.default)(inputRefs, function (result, value) {
        var newObj = result;
        if (newObj && 'function' === typeof value.getValue) {
          newObj[value.props.inputFieldName] = value.getValue();
          return newObj;
        }
        return;
      }, {});
      this.toggleSubmitted(true);
      this.props.submitAction(e.target.parentElement, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        setTimeout(function () {
          var _this2$props;
          _this2.toggleSubmitted(false);
          (_this2$props = _this2.props).submitCallback.apply(_this2$props, args);
        }, 0);
      }, inputRefs, getValues);
    }

    // Helper method to check if an element is in viewport
  }, {
    key: "isScrolledIntoView",
    value: function isScrolledIntoView(el) {
      var $el = $(el);
      var $window = $(window);
      var documentViewTop = $window.scrollTop();
      var documentViewBottom = documentViewTop + $window.height();
      var elTop = $el.offset().top;
      var elBot = elTop + $el.height();
      return elBot <= documentViewBottom && elTop >= documentViewTop;
    }
  }, {
    key: "scrollErrorIntoView",
    value: function scrollErrorIntoView() {
      var _this3 = this;
      var firstError = false;
      var componentRefs = (0, _mapValues.default)(this.refs, function (value) {
        return _this3.isInputWrappedFunction(value);
      }); //keeping this.refs for backwards compatibility for services still using deprecated string refs
      var refs = _objectSpread(_objectSpread(_objectSpread({}, componentRefs), this.formRefs), this.props.inputRefs);
      (0, _forOwn.default)(refs, function (value) {
        if (!value.isValid()) {
          firstError = value;
          return false;
        }
      });
      if (firstError) {
        var node = _reactDom.default.findDOMNode(firstError);

        // Only scroll to error if it is in viewport
        if (!this.isScrolledIntoView(node)) {
          $('html, body').animate({
            scrollTop: $(node).offset().top -= 100
          }, 1000);
        }
      }
    }
  }, {
    key: "inputsValid",
    value: function inputsValid() {
      var _this4 = this;
      var scrollToError = this.props.scrollToError;
      var noErrors = true;
      if (scrollToError) {
        this.scrollErrorIntoView();
      }
      var componentRefs = (0, _mapValues.default)(this.refs, function (value) {
        return _this4.isInputWrappedFunction(value);
      }); //keeping this.refs for backwards compatibility for services still using deprecated string refs
      var inputRefs = (0, _assign.default)({}, componentRefs, this.formRefs, this.props.inputRefs);
      (0, _forEach.default)(inputRefs, function (value) {
        var isValid = value.isValid();
        if (!isValid) {
          noErrors = false;
        }
      });
      return noErrors;
    }
  }, {
    key: "toggleSubmitted",
    value: function toggleSubmitted(p) {
      var submitted = p;
      return this.setState({
        submitted: submitted
      });
    }

    // will not work on custom elements unless they have
    // a clearValue function
  }, {
    key: "clearForm",
    value: function clearForm(e) {
      var _this5 = this;
      if (e) e.preventDefault();
      var clearFilterFn = this.props.clearFilterFn;
      var componentRefs = (0, _mapValues.default)(this.refs, function (value) {
        return _this5.isInputWrappedFunction(value);
      }); //keeping this.refs for backwards compatibility for services still using deprecated string refs
      var inputRefs = (0, _assign.default)({}, componentRefs, this.formRefs, this.props.inputRefs);
      // clear the form inputs & errors
      (0, _forEach.default)(inputRefs, function (ref) {
        ref.clearValue();
      });
      if (clearFilterFn && (0, _isFunction.default)(clearFilterFn)) clearFilterFn();
    }
  }, {
    key: "shouldButtonBeDisabled",
    value: function shouldButtonBeDisabled() {
      var isButtonDisabled = this.props.isButtonDisabled;
      if (false === isButtonDisabled) {
        return isButtonDisabled;
      }
      return this.state.submitted || isButtonDisabled || false;
    }
  }, {
    key: "shouldButtonBeSpinning",
    value: function shouldButtonBeSpinning() {
      var _this$props = this.props,
        isButtonDisabled = _this$props.isButtonDisabled,
        isDisableSpinning = _this$props.isDisableSpinning;
      if (isDisableSpinning) {
        return false;
      }
      if (false === isButtonDisabled) {
        return isButtonDisabled;
      }
      return this.state.submitted || isButtonDisabled || false;
    }
  }, {
    key: "renderInputElements",
    value: function renderInputElements() {
      var _this6 = this;
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.formInputs;
      var _this$props$ignoreTex = this.props.ignoreTextAreaBlurValidation,
        ignoreTextAreaBlurValidation = _this$props$ignoreTex === void 0 ? false : _this$props$ignoreTex;
      return elements.map(function (input, i) {
        var custom = input.custom;
        if (custom) {
          return /*#__PURE__*/_react.default.createElement("div", {
            key: "custom-field-".concat(i),
            className: "form-inputs"
          }, (0, _isFunction.default)(custom) ? custom() : custom);
        }
        return /*#__PURE__*/_react.default.createElement(_inputField.InputField, _extends({}, input, {
          useBootstrapGrid: _this6.props.useBootstrapGrid,
          ignoreTextAreaBlurValidation: ignoreTextAreaBlurValidation,
          key: input.elementID || i,
          ref: function ref(_ref) {
            var actualRef = _this6.isInputWrappedFunction(_ref);
            (0, _isFunction.default)(input.ref) ? input.ref(actualRef) : _this6.formRefs[input.ref || "input ".concat(i + 1)] = actualRef;
          }
        }));
      });
    }
  }, {
    key: "renderFormGroups",
    value: function renderFormGroups() {
      var _this7 = this;
      var formGroups = this.props.formGroups;
      if (formGroups) {
        return formGroups.map(function (group, i) {
          // if group is an array, render as input fields
          var isInputArray = Array.isArray(group);
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "clearfix",
            key: "group-".concat(i)
          }, isInputArray ? _this7.renderInputElements(group) : group);
        });
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var useBootstrapGrid = this.props.useBootstrapGrid;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-".concat(this.props.formStyle)
      }, /*#__PURE__*/_react.default.createElement("form", {
        id: this.props.id || this.props.formname,
        name: this.props.formname,
        className: this.props.formClassString
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)({
          'row': useBootstrapGrid
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)({
          'col-xs-12': useBootstrapGrid
        })
      }, this.getHeading(), this.getSmallHeading(), this.getSubheading(), this.getDescription()), this.props.extended ? this.renderFormGroups() : this.renderInputElements(), this.props.additionalBody, !!this.props.errorText && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)({
          'col-xs-12': useBootstrapGrid
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "help-block text-danger text-left"
      }, this.props.errorText)), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(this.props.containerClass, {
          'container-fluid': useBootstrapGrid
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(this.props.rowClass, {
          'row': useBootstrapGrid
        })
      }, this.props.beforeCTA, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(this.props.btnColSize, {
          'col-xs-12': useBootstrapGrid && !this.props.btnColSize
        })
      }, /*#__PURE__*/_react.default.createElement(_ctaButton.CTAButton, {
        attributes: _objectSpread({}, this.props.ctaButtonAttributes),
        onClickAction: this.submitForm,
        buttonText: this.props.buttonText,
        classNameString: this.props.buttonClass,
        isDisabled: this.shouldButtonBeDisabled(),
        spinning: this.shouldButtonBeSpinning(),
        spinnerColor: this.props.spinnerColor ? this.props.spinnerColor : 'initial'
      }), this.props.clearFilterFn && (0, _isFunction.default)(this.props.clearFilterFn) && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('text-center', {
          'col-xs-12': useBootstrapGrid
        })
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-link remove-click-styling",
        onClick: this.clearForm
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "form_component.form_component.clear",
        defaultMessage: "Clear"
      })))), this.props.afterCTA)))));
    }
  }]);
  return FormBuilder;
}(_react.Component);
FormBuilder.defaultProps = {
  formClassString: 'form-horizontal',
  errorText: '',
  useBootstrapGrid: true
};
FormBuilder.propTypes = {
  formname: _propTypes.default.string.isRequired,
  containerClass: _propTypes.default.string,
  formStyle: _propTypes.default.oneOf(['modal', 'modal-plus', 'full', 'standard']),
  formInputs: _propTypes.default.array,
  formGroups: _propTypes.default.array,
  formClassString: _propTypes.default.string,
  heading: _propTypes.default.string,
  smallHeading: _propTypes.default.string,
  subHeading: _propTypes.default.string,
  description: _propTypes.default.string,
  additionalBody: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
  errorText: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.bool]),
  submitAction: _propTypes.default.func,
  submitCallback: _propTypes.default.func,
  buttonText: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  buttonClass: _propTypes.default.string,
  isButtonDisabled: _propTypes.default.bool,
  extended: _propTypes.default.bool,
  scrollToError: _propTypes.default.bool,
  btnColSize: _propTypes.default.string,
  isDisableSpinning: _propTypes.default.bool,
  customLabel: _propTypes.default.object,
  ctaButtonAttributes: _propTypes.default.object,
  inputRefs: _propTypes.default.array,
  rowClass: _propTypes.default.string,
  ignoreTextAreaBlurValidation: _propTypes.default.bool,
  useBootstrapGrid: _propTypes.default.bool
};